import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useQuery } from "@apollo/client/react";

import { ASSETS_COLLECTION_QUERY } from "../../../constants/graphql";

export default function AddReferenceAssetModal({ projectId, onClose, onAdd }) {
  const [search, setSearch] = useState("");
  const [selectedAsset, setSelectedAsset] = useState(null);

  const { data, loading } = useQuery(ASSETS_COLLECTION_QUERY, {
    variables: {
      projectId,
      search,
      type: "Asset",
      hideDepletedAssets: false,
      page: 1,
      limit: 20,
    },
  });

  const assets = data?.assetsCollection?.collection || [];

  const handleAdd = async () => {
    if (selectedAsset) {
      await onAdd(selectedAsset.id);
    }
  };

  return (
    <Dialog open fullWidth maxWidth="md" onClose={onClose}>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Select Reference Item</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search assets..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            sx={{
              maxHeight: 400,
              overflowY: "auto",
              border: "1px solid #e0e0e0",
              borderRadius: 1,
            }}
          >
            {assets.length === 0 ? (
              <Box py={4} display="flex" justifyContent="center">
                <Typography color="textSecondary">No assets found</Typography>
              </Box>
            ) : (
              assets.map((asset) => (
                <Box
                  key={asset.id}
                  sx={{
                    p: 2,
                    cursor: "pointer",
                    borderBottom: "1px solid #e0e0e0",
                    backgroundColor: selectedAsset?.id === asset.id ? "#e3f2fd" : "white",
                    "&:hover": {
                      backgroundColor: selectedAsset?.id === asset.id ? "#e3f2fd" : "#f5f5f5",
                    },
                  }}
                  onClick={() => setSelectedAsset(asset)}
                >
                  <Typography fontWeight={600} variant="body2">
                    {asset.itemId}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {asset.description}
                  </Typography>
                  {asset.skuNumber && (
                    <Typography variant="caption" color="textSecondary">
                      SKU Number: {asset.skuNumber}
                    </Typography>
                  )}
                </Box>
              ))
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleAdd}
          variant="contained"
          disabled={!selectedAsset}
        >
          Add Reference Item
        </Button>
      </DialogActions>
    </Dialog>
  );
}

